import { TableCell, TableRow, Typography } from '@material-ui/core';
import { useCadastros } from '../../../../service/app/providers/cadastros-provider';
import { CardPedidosProps } from './card-pedidos-props';
import { useCardPedidosStyles } from './card-pedidos-styles';
import { formatDataHora } from '../../../../utils/format-data-hora';
import { alterarCorStatusPedido } from './utils/alterar-cor-pedido';
import { alterarNomePedido } from './utils/alterar-nome-pedido';
import classNames from 'classnames';

export const CardPedidos = ({
   model,
   lojaId,
   index
}: CardPedidosProps) => {
   const classes = useCardPedidosStyles();
   const { abrirDetalhesPedidos } = useCadastros()

   return (
      <>
         <TableRow className={classNames(classes.card, index % 2 === 0 && classes.cardCinza)}
            onClick={() => abrirDetalhesPedidos(lojaId, model.id, '/detalhes', true)}>
            <TableCell align='center'>{model.dadosIntegracao?.nomeIntegrador}</TableCell>
            <TableCell align='center'>{model?.codigoPedido}</TableCell>
            <TableCell align='center'>{model?.cliente?.nome}</TableCell>
            <TableCell align='center'>{model?.valorTotal?.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</TableCell>
            <TableCell align='center'>{formatDataHora(new Date(model?.dataCriacao))}</TableCell>
            <TableCell>
               <Typography
                className={classes.titleStatusPedido}
                style={{
                  background: alterarCorStatusPedido(model?.tpStatusPedido),
                  whiteSpace: 'nowrap'
                }}
               >
                {alterarNomePedido(model?.tpStatusPedido)?.split(' ').join('\u00A0')}
               </Typography>
            </TableCell>
         </TableRow>
      </>
   );
};
